import { gql } from 'apollo-boost';

export const CURRICULUMS_QUERY = gql`
  query curriculums {
    curriculums(useSegmentationFilter: false) {
      edges {
        node {
          id
          tagIds
          locales {
            locale
            name
            description
          }
          thumbnailImage {
            id
            url
          }
          courses(useSegmentationFilter: false) {
            edges {
              node {
                id
              }
            }
          }
          localeIds
          companyRelationshipIds
          productIds
          brandIds
          categoryIds
          learningProfileIds
          metadata
        }
      }
    }
  }
`;
